module.exports = __webpack_public_path__ + "static/3-0433b52946f7c510953fdc1b1b1c5dd2.jpg";